<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" class="form-field-with-scrollbar">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label }}
  </mat-label>

  @if (!isDisabled) {
    <input
      matInput
      class="mat-tag-input"
      [class.with-tags]="value && value.length"
      [(ngModel)]="inputText"
      (ngModelChange)="onSearchInputChange($event)"
      (keyup)="onKeyUp($event)"
      [placeholder]="placeholder"
      [errorStateMatcher]="this"
      [required]="isRequiredControl"
      spellcheck="false"
      [matAutocomplete]="auto"
      autocomplete="off"
    />
  }
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    @for (option of filteredOptions; track option) {
      <mat-option class="mat-option-item" [value]="option">
        <span class="mat-option-text" [title]="option">{{ option }}</span>
      </mat-option>
    }
  </mat-autocomplete>
  <nimbus-mat-tag-list [(ngModel)]="value" [disabled]="isDisabled" [inputText]="inputText"> </nimbus-mat-tag-list>
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
</mat-form-field>
